<button type="button" class="add-btn" [class.add-btn--disabled]="disabled" (click)="handleClick()">
  <lib-elux-icon color="#fff" [icon]="'Plus-Add.svg'" size="18" sizeType="px" />
  <span class="subtitle-2">{{ text }}</span>
</button>
